import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/app/foretag/$companyId')({
  component: () => <h1>Företagssida</h1>,
})
